// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2oumR","title":"Images90_title__1PJPV","images":"Images90_images__koQQd"};